// Import the desired analytics libs
import './segment-initial.js';

import AnalyticsService from './AnalyticsService';

export default AnalyticsService;
